import { render, staticRenderFns } from "./selfphoto-notice.vue?vue&type=template&id=58cbee34&scoped=true&"
import script from "./selfphoto-notice.vue?vue&type=script&lang=js&"
export * from "./selfphoto-notice.vue?vue&type=script&lang=js&"
import style0 from "./selfphoto-notice.vue?vue&type=style&index=0&id=58cbee34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbee34",
  null
  
)

export default component.exports